export interface UnipileBannerState {
  reconnectRequiredByChannelId: Record<string, boolean>;
}

const ui = {
  state: {
    unipile: {
      reconnectRequiredByChannelId: {} as Record<string, boolean>,
    } as UnipileBannerState,
  },
  getters: {
    unipileReconnectRequiredByChannelId: (state: any) =>
      state.unipile.reconnectRequiredByChannelId as Record<string, boolean>,
  },
  mutations: {
    setUnipileReconnectRequired(state: any, payload: { channelId: string; required: boolean }) {
      const { channelId, required } = payload;
      state.unipile.reconnectRequiredByChannelId = {
        ...state.unipile.reconnectRequiredByChannelId,
        [channelId]: required,
      };
    },
  },
  actions: {
    markUnipileReconnectRequired(
      { commit }: any,
      payload: { channelId: string; required: boolean }
    ) {
      commit("setUnipileReconnectRequired", payload);
    },
  },
};

export default ui;
